// Copyright (c) Cosmo Tech.
// Licensed under the MIT license.

// Function to get module key from its name
export const sanitizeModuleName = (moduleName) => (moduleName != null ? moduleName.trim() : '');
export const areModuleNamesEqual = (nameA, nameB) => nameA.trim().toLowerCase() === nameB.trim().toLowerCase();

export const getModulesFromGraph = (graph) => {
  const uniqueModules = new Set();

  graph.getElements().forEach((element) => {
    const elementModule = element.get('module');
    if (elementModule) uniqueModules.add(elementModule);
  });

  return Array.from(uniqueModules).map(sanitizeModuleName);
};
